import { ApiError } from './api';
import type { MessageKey } from './i18n';

/**
 * Проверка на настоящую ошибку сети (fetch в браузерах падает с TypeError при
 * отсутствии соединения, сбросе соединения или сбое DNS). Обычные программные
 * TypeError вроде undefined.map не должны выдаваться за обрыв связи!
 */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof TypeError) {
    const msg = error.message.toLowerCase();
    return (
      msg.includes('failed to fetch') ||
      msg.includes('networkerror') ||
      msg.includes('network error') ||
      msg.includes('load failed') ||
      msg.includes('network request failed') ||
      msg.includes('connection refused')
    );
  }
  return false;
}

/**
 * Человеческое сообщение об ошибке. Сообщение с сервера уже на нужном языке
 * и обычно точнее нашего, поэтому показываем его; свои тексты — для случаев,
 * когда сервер не ответил вовсе.
 */
export function errorMessage(error: unknown, t: (key: MessageKey) => string): string {
  if (error instanceof ApiError) {
    if (error.message) return error.message;
    switch (error.code) {
      case 'capability_unsupported':
        return t('error.capability');
      case 'conflict':
        return t('error.conflict');
      case 'store_blocked_by_cloudflare':
        return t('error.cloudflare');
      case 'store_unavailable':
        return t('error.storeUnavailable');
      case 'forbidden':
        return t('error.forbidden');
      default:
        return t('error.unknown');
    }
  }
  if (isNetworkError(error)) return t('app.offline');
  if (error instanceof Error && error.message) return error.message;
  return t('error.unknown');
}

